<template>
	<div class="display-flex flex-row flex-align-center flex-wrap flex-1">
		<slot />
		<div class="header-right-side margin-left-auto">
			<slot name="right-side" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'WizardStepHeaderWithRightSideWrapper',
};
</script>

<style lang="scss" scoped>
.header-right-side {
	color: #303133;
	h3 a {
		color: #303133;
	}
}
</style>
